import * as occlTemplates from '@mfe/components/templates/occl';
import { configStore } from '@mfe/store';
import type { LitElement } from 'lit';

import type { TemplateNames } from '../TemplateResolver';
import TemplateResolver from '../TemplateResolver';

type Constructor<T = object> = new (...args: any[]) => T; // eslint-disable-line @typescript-eslint/no-explicit-any

export declare class TemplatingMixinI {
  getTemplateFn<T extends TemplateNames>(templateName: T) : OmitThisParameter<typeof occlTemplates[T]>;
}

export const TemplatingMixin = <T extends Constructor<LitElement>>(superClass: T) => {
  class TemplatingMixinClass extends superClass {
    getTemplateFn<U extends TemplateNames>(templateName: U) {
      return TemplateResolver.getInstance(configStore.theme)
        .resolve(templateName)
        .bind(this) as OmitThisParameter<typeof occlTemplates[U]>;
    }
  }
  return TemplatingMixinClass as Constructor<TemplatingMixinI> & T;
};
